import * as Yup from 'yup';

const templateBodyContent = Yup.string();

export default templateBodyContent;
